import { useEffect, useState } from "react";
import axios from "axios";
import ScoreCard from "./view/ScoreCard"
import GoogleTranslate from "./layout/GoogleTranslate";

export default function Quiz() {
  const [resultview, setResultview] = useState(localStorage.getItem("resultView") === "true");
  const [, setResultCount] = useState(0);
  const [data, setData] = useState([]);
  const courseId = localStorage.getItem("courseId");
  const [pageCount, setPageCount] = useState(0);
  const [questionCount, setQuestionCount] = useState(0);
   const [view, setview] = useState(false);

  const options = [];

  function getData(courseId, page) {
    axios.get(`${process.env.REACT_APP_BASE_URL}api/question/open/getQuestionByCourseId/${courseId}/page/${page}`)
    .then((result) => setData(result.data))
    .catch((err) => console.log(err));
  }

  function createCandidate(count, page) {
    const obj = new FormData();
    obj.append("fullname", localStorage.getItem("fullname"));
    obj.append("passkey", localStorage.getItem("passkey"));
    obj.append("courseId", localStorage.getItem("courseId"));
    obj.append("score", count + "/" + data.length);
    obj.append("description", "Excercise " + (Number(page) + 1));
    const objdata = Object.fromEntries(obj.entries());
    axios.post(`${process.env.REACT_APP_BASE_URL}api/candidate/open/createCandidate`,objdata)
    .then((result) =>localStorage.setItem("candidateId", result.data.id))
    .catch((err) => console.log(err));
  }

  function submitHandler(e) {
    e.preventDefault();
    let count = 0;
    for (let i = 0; i < e.target.elements.length; i++) {
      if (e.target.elements[i].checked && e.target.elements[i].value === "true") {
        count++;
      }
    }
    setResultCount(count);
    setResultview(true);
    localStorage.setItem("resultView", "true");
    createCandidate(count, pageCount);
    alert(`Your result is ${count}/${data.length}!`);
  }

  function countQuestion(courseId) {
    axios.get(`${process.env.REACT_APP_BASE_URL}api/question/open/countQuestionByCourseId/${courseId}`)
    .then((result) => setQuestionCount(result.data))
    .catch((err) => console.log(err));
  }

  for (let index = 0; index < Math.ceil(questionCount / 10); index++) {
    options.push(
      <option key={index} value={index}>
        Exercise {index + 1}
      </option>
    );
  }

  useEffect(() =>getData(courseId, pageCount), [courseId, pageCount]);
  useEffect(() =>countQuestion(courseId), [courseId]);

  const currentStart = Number(pageCount) * 10 + 1;
  const currentEnd = Math.min(Number(pageCount) * 10 + data.length,questionCount);
  const progress =questionCount > 0? Math.round((currentEnd / questionCount) * 100): 0;

  return (
    <><div className="container-fluid">
      {view && <>
        <div className="dialog-container">
          <ScoreCard event={setview}></ScoreCard>
        </div>
      </>}
    </div>
    <div className="quiz-page">
        {/* Background decorations */}
        <div className="bg-circle circle-one"></div>
        <div className="bg-circle circle-two"></div>

        <div className="quiz-wrapper">

          {/* Header */}
          <header className="quiz-header notranslate">
            <div>
              <span className="quiz-brand">ONLINE<span>QUIZ</span></span>
              <h6>{"Hi, " + localStorage.getItem("fullname") + "!"}</h6>
            </div>

            <div className="header-actions">
              <button
                className="header-btn score-btn"
                onClick={() => setview(true)}
              >
                <span>🏆</span>
                Score Card
              </button>

              <button
                className="header-btn logout-btn"
                onClick={() => window.location.replace("/")}
              >
                <span>↪</span>
                Logout
              </button>
            </div>
            <div>
              <GoogleTranslate />
            </div>
          </header>

          {/* Main quiz card */}
          <main className="quiz-card">

            {/* Quiz top section */}
            <div className="quiz-top notranslate">

              <div>
                <span className="exercise-label">
                  {localStorage.getItem("courseName")} Exercise {Number(pageCount) + 1}
                </span>

                <h1>
                  Knowledge <span>Challenge</span>
                </h1>

                <p className="question-info">
                  Questions {currentStart}-{currentEnd} of {questionCount}
                </p>
              </div>

              {!resultview && (
                <div className="exercise-select-wrapper">
                  <label htmlFor="exercise">
                    Select Exercise
                  </label>

                  <select
                    id="exercise"
                    name="exercise"
                    className="exercise-select"
                    value={pageCount}
                    onChange={(e) => {
                      setPageCount(Number(e.target.value));
                      setResultview(false);
                      localStorage.removeItem("resultView");
                    } }
                  >
                    {options}
                  </select>
                </div>
              )}
            </div>

            {/* Progress bar */}
            <div className="progress-section notranslate">
              <div className="progress-text">
                <span>Quiz Progress</span>
                <strong>{progress}%</strong>
              </div>

              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>

            {/* Questions */}
            <form onSubmit={submitHandler}>
              <div className="questions-container">

                {data.map((question, index) => (
                  <div className="question-card" key={question.id}>
                    <div className="question-number">{index + 1 + "."}</div>
                    <div className="question-content">
                      <h3>{question.question}</h3>

                      <div className="options-grid">

                        <label className="answer-option">
                          <input
                            type="radio"
                            name={`question-${question.id}`}
                            value={question.option1 === question.answer}
                            required
                            disabled={resultview} />
                          <span className="custom-radio"></span>
                          <span className="option-text">
                            {question.option1}
                          </span>
                        </label>

                        <label className="answer-option">
                          <input
                            type="radio"
                            name={`question-${question.id}`}
                            value={question.option2 === question.answer}
                            required
                            disabled={resultview} />
                          <span className="custom-radio"></span>
                          <span className="option-text">
                            {question.option2}
                          </span>
                        </label>

                        <label className="answer-option">
                          <input
                            type="radio"
                            name={`question-${question.id}`}
                            value={question.option3 === question.answer}
                            required
                            disabled={resultview} />
                          <span className="custom-radio"></span>
                          <span className="option-text">
                            {question.option3}
                          </span>
                        </label>

                        <label className="answer-option">
                          <input
                            type="radio"
                            name={`question-${question.id}`}
                            value={question.option4 === question.answer}
                            required
                            disabled={resultview} />
                          <span className="custom-radio"></span>
                          <span className="option-text">
                            {question.option4}
                          </span>
                        </label>

                      </div>

                      {/* Correct answer */}
                      {resultview && (
                        <div className="correct-answer">
                          <div className="correct-icon">✓</div>

                          <div>
                            <small>Correct Answer</small>
                            <strong className="text-translate">{question.answer}</strong>
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                ))}

              </div>

              {/* Submit */}
              {!resultview && (
                <div className="submit-area notranslate">
                  <button type="submit" className="submit-btn">
                    <span>Submit Quiz</span>
                    <span className="submit-arrow">→</span>
                  </button>
                </div>
              )}

              {/* Result message */}
              {resultview && (
                <div className="result-banner">
                  <div className="result-icon">✓</div>

                  <div>
                    <h3>Quiz Submitted!</h3>
                    <p>
                      Your answers have been recorded successfully.
                    </p>
                  </div>

                  <button
                    type="button"
                    className="view-score-btn"
                    onClick={() => (window.location.href = "/score-card")}
                  >
                    View Score →
                  </button>
                </div>
              )}

            </form>
          </main>
        </div>

        {/* Component styles */}
        <style>{`

        .quiz-page {
          height: 98vh;
          padding: 30px 20px;
          position: relative;
          overflow-Y: auto;
          overflow-x: hidden;
          font-family:
            Inter,
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            sans-serif;
          color: #172033;
        }

        .bg-circle {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
          filter: blur(1px);
        }

        .circle-one {
          width: 350px;
          height: 350px;
          background: rgba(99, 102, 241, 0.08);
          top: -150px;
          left: -120px;
        }

        .circle-two {
          width: 400px;
          height: 400px;
          background: rgba(14, 165, 233, 0.07);
          bottom: -200px;
          right: -150px;
        }

        .quiz-wrapper {
          max-width: 1150px;
          margin: auto;
          position: relative;
          z-index: 2;
        }

        /* HEADER */

        .quiz-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 25px;
          padding: 0 5px;
        }

        .quiz-brand {
          font-size: 24px;
          font-weight: 900;
          letter-spacing: -1px;
          color: #111827;
        }

        .quiz-brand span {
          color: rgb(74, 114, 188);
        }

        .quiz-subtitle {
          margin: 3px 0 0;
          font-size: 13px;
          color: #94a3b8;
        }

        .header-actions {
          display: flex;
          gap: 10px;
        }

        .header-btn {
          border: none;
          border-radius: 12px;
          padding: 11px 17px;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .header-btn:hover {
          transform: translateY(-2px);
        }

        .score-btn {
          background: white;
          color: #475569;
          border: 1px solid #e2e8f0;
          box-shadow: 0 5px 15px rgba(15, 23, 42, 0.05);
        }

        .logout-btn {
          background: #fff1f2;
          color: #e11d48;
        }

        /* MAIN CARD */

        .quiz-card {
          background: rgba(255, 255, 255, 0.96);
          border: 1px solid rgba(226, 232, 240, 0.8);
          border-radius: 25px;
          box-shadow: 0 25px 60px rgba(15, 23, 42, 0.08);
          overflow: auto;
        }

        .quiz-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 40px 45px 30px;
          border-bottom: 1px solid #f1f5f9;
        }

        .exercise-label {
          color: rgb(74, 114, 188);
          font-size: 15px;
          font-weight: 500;
          letter-spacing: 1.5px;
        }

        .quiz-top h1 {
          margin: 8px 0 5px;
          font-size: 36px;
          line-height: 1.1;
          letter-spacing: -1.5px;
          color: #111827;
        }

        .quiz-top h1 span {
          color: rgb(74, 114, 188);
        }

        .question-info {
          margin: 0;
          color: #94a3b8;
          font-size: 14px;
        }

        .exercise-select-wrapper {
          min-width: 190px;
        }

        .exercise-select-wrapper label {
          display: block;
          font-size: 11px;
          font-weight: 700;
          color: #64748b;
          margin-bottom: 7px;
        }

        .exercise-select {
          width: 100%;
          border: 1px solid #e2e8f0;
          background: #f8fafc;
          padding: 12px 14px;
          border-radius: 11px;
          outline: none;
          font-size: 14px;
          font-weight: 600;
          color: #334155;
          cursor: pointer;
        }

        .exercise-select:focus {
          border-color: #818cf8;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        /* PROGRESS */

        .progress-section {
          padding: 22px 45px 10px;
        }

        .progress-text {
          display: flex;
          justify-content: space-between;
          margin-bottom: 9px;
          font-size: 12px;
          color: #94a3b8;
        }

        .progress-text strong {
          color: #6366f1;
        }

        .progress-bar {
          height: 7px;
          background: #eef2ff;
          border-radius: 20px;
          // overflow: hidden;
        }

        .progress-fill {
          height: 100%;
          background: rgb(74, 114, 188);
          border-radius: 20px;
          transition: width 0.4s ease;
        }

        /* QUESTIONS */

        .questions-container {
          padding: 25px 45px 10px;
        }

        .question-card {
          display: flex;
          gap: 22px;
          padding: 25px 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .question-card:last-child {
          border-bottom: none;
        }

        .question-number {
          flex-shrink: 0;
          width: 43px;
          height: 43px;
          border-radius: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #eef2ff;
          color: rgb(74, 114, 188);
          font-size: 13px;
          font-weight: 800;
        }

        .question-content {
          flex: 1;
        }

        .question-content h3 {
          margin: 0px 0 20px;
          color: #1e293b;
          font-size: 17px;
          line-height: 1.55;
          font-weight: 700;
        }

        .options-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }

        .answer-option {
          position: relative;
          display: flex;
          align-items: center;
          gap: 13px;
          min-height: 56px;
          padding: 13px 17px;
          border: 1px solid #e2e8f0;
          border-radius: 13px;
          background: #fff;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .answer-option:hover {
          border-color: #a5b4fc;
          background: #f8faff;
          transform: translateY(-1px);
          box-shadow: 0 5px 15px rgba(99, 102, 241, 0.07);
        }

        .answer-option input {
          position: absolute;
          opacity: 0;
        }

        .custom-radio {
          width: 19px;
          height: 19px;
          flex-shrink: 0;
          border: 2px solid #cbd5e1;
          border-radius: 50%;
          position: relative;
          transition: all 0.2s ease;
        }

        .answer-option input:checked + .custom-radio {
          border-color: #6366f1;
          background: #6366f1;
          box-shadow: inset 0 0 0 4px white;
        }

        .answer-option:has(input:checked) {
          border-color: #818cf8;
          background: #eef2ff;
        }

        .option-text {
          font-size: 14px;
          line-height: 1.4;
          color: #475569;
        }

        /* CORRECT ANSWER */

        .correct-answer {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 15px;
          padding: 12px 15px;
          background: #f0fdf4;
          border: 1px solid #bbf7d0;
          border-radius: 12px;
        }

        .correct-icon {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #22c55e;
          color: white;
          font-weight: 900;
        }

        .correct-answer small {
          display: block;
          color: #16a34a;
          font-size: 11px;
          font-weight: 700;
          margin-bottom: 2px;
        }

        .correct-answer strong {
          color: #166534;
          font-size: 14px;
        }

        /* SUBMIT */

        .submit-area {
          padding: 30px 45px 40px;
          text-align: center;
        }

        .submit-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          min-width: 190px;
          border: none;
          border-radius: 13px;
          padding: 15px 22px;
          background: rgb(74, 114, 188);
          color: white;
          font-size: 15px;
          cursor: pointer;
          box-shadow: 0 12px 25px rgba(99, 102, 241, 0.25);
          transition: all 0.2s ease;
        }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 16px 30px rgba(99, 102, 241, 0.3);
        }

        .submit-arrow {
          font-size: 20px;
        }

        .submit-note {
          margin: 12px 0 0;
          color: #94a3b8;
          font-size: 12px;
        }

        /* RESULT */

        .result-banner {
          margin: 15px 45px 40px;
          padding: 20px;
          display: flex;
          align-items: center;
          gap: 15px;
          border-radius: 15px;
          background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
          border: 1px solid #bbf7d0;
        }

        .result-icon {
          width: 45px;
          height: 45px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #22c55e;
          color: white;
          font-size: 20px;
          font-weight: 900;
        }

        .result-banner h3 {
          margin: 0 0 3px;
          color: #166534;
          font-size: 16px;
        }

        .result-banner p {
          margin: 0;
          color: #4d7c5c;
          font-size: 13px;
        }

        .view-score-btn {
          margin-left: auto;
          border: none;
          background: #166534;
          color: white;
          padding: 10px 15px;
          border-radius: 9px;
          font-weight: 700;
          cursor: pointer;
        }

        /* FOOTER */

        .quiz-footer {
          display: flex;
          justify-content: space-between;
          padding: 18px 5px;
          color: #94a3b8;
          font-size: 12px;
        }

        /* RESPONSIVE */

        @media (max-width: 768px) {
          .quiz-page {
            height: 90vh;
            padding: 15px 10px;
          }

          .quiz-header {
            align-items: flex-start;
            gap: 15px;
          }

          .header-actions {
            gap: 6px;
          }

          .header-btn {
            padding: 9px 10px;
            font-size: 12px;
          }

          .quiz-brand {
            font-size: 19px;
          }

          .quiz-top {
            padding: 28px 22px 23px;
            display: block;
          }

          .quiz-top h1 {
            font-size: 28px;
          }

          .exercise-select-wrapper {
            margin-top: 20px;
          }

          .progress-section {
            padding: 20px 22px 5px;
          }

          .questions-container {
            padding: 15px 22px;
          }

          .question-card {
            gap: 13px;
          }

          .question-number {
            width: 35px;
            height: 35px;
            border-radius: 10px;
          }

          .question-content h3 {
            font-size: 15px;
          }

          .options-grid {
            grid-template-columns: 1fr;
          }

          .submit-area {
            padding: 25px 22px 30px;
          }

          .result-banner {
            margin: 15px 22px 30px;
            flex-wrap: wrap;
          }

          .view-score-btn {
            width: 100%;
            margin-left: 0;
          }

          .quiz-footer {
            padding: 15px 5px;
            flex-direction: column;
            gap: 5px;
            text-align: center;
          }
        }

        @media (max-width: 450px) {
          .quiz-header {
            flex-direction: column;
          }

          .header-actions {
            width: 100%;
          }

          .header-btn {
            flex: 1;
          }

          .question-card {
            flex-direction: column;
          }

          .question-number {
            width: 38px;
          }

          .answer-option {
            min-height: 52px;
          }
        }
      `}</style>
      </div></>
  );
}
